import { useEffect, useMemo, useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import OrcamentosService from '../../services/database/OrcamentosService'
import { toast } from 'react-toastify'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import Swal from 'sweetalert2'
import moment from 'moment'

import { CustomSpinner } from '../../components/CustomSpinner'
import { CustomButton } from '../../components/CustomButton'
import {
  CaretDown,
  CaretUp,
  PencilFill,
  PlusCircleFill,
  PrinterFill,
  ShareFill,
  Copy,
  ArrowClockwise,
  TrashFill,
  FileEarmarkText,
  Search,
} from 'react-bootstrap-icons'
import clientesPDF from '../orcamento/report'
import { formatDate } from '../../utils/formatDate'
import { formatPrice } from '../../utils/formatPrice'
import { useNavigate } from 'react-router-dom'
import { useOrderTable } from '../../hooks/useOrderTable'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

const styles = {
  page: {
    background: '#F0F2F5',
    minHeight: '100vh',
    paddingBottom: 40,
  },
  container: {
    padding: '28px 32px',
    maxWidth: 1400,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 24,
    flexWrap: 'wrap',
    gap: 12,
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  titleIcon: {
    background: 'linear-gradient(135deg, #e67e22, #f39c12)',
    borderRadius: 12,
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 20,
    flexShrink: 0,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: '#1a1a2e',
    margin: 0,
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: 13,
    color: '#888',
    margin: 0,
  },
  headerActions: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
  btnPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 18px',
    background: 'linear-gradient(135deg, #e67e22, #f39c12)',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(230,126,34,0.35)',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
  },
  btnSecondary: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '9px 14px',
    background: '#fff',
    color: '#555',
    border: '1.5px solid #e0e0e0',
    borderRadius: 10,
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  toolbar: {
    padding: '18px 24px',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'flex-end',
    gap: 16,
    flexWrap: 'wrap',
  },
  toolbarGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    margin: 0,
  },
  select: {
    border: '1.5px solid #e8e8e8',
    borderRadius: 8,
    padding: '8px 12px',
    fontSize: 13,
    color: '#333',
    background: '#fafafa',
    outline: 'none',
    cursor: 'pointer',
  },
  searchWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    position: 'absolute',
    left: 12,
    color: '#aaa',
    fontSize: 14,
    pointerEvents: 'none',
  },
  searchInput: {
    border: '1.5px solid #e8e8e8',
    borderRadius: 8,
    padding: '8px 12px 8px 34px',
    fontSize: 13,
    color: '#333',
    background: '#fafafa',
    outline: 'none',
    width: 280,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 13.5,
  },
  thead: {
    background: '#F7F8FA',
  },
  th: {
    padding: '13px 16px',
    textAlign: 'left',
    fontWeight: 700,
    color: '#555',
    background: '#F7F8FA',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '2px solid #EBEBEB',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    userSelect: 'none',
  },
  thNoSort: {
    padding: '13px 16px',
    textAlign: 'left',
    fontWeight: 700,
    color: '#555',
    background: '#F7F8FA',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '2px solid #EBEBEB',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '13px 16px',
    borderBottom: '1px solid #F2F2F2',
    color: '#333',
    verticalAlign: 'middle',
  },
  tdMuted: {
    padding: '13px 16px',
    borderBottom: '1px solid #F2F2F2',
    color: '#999',
    verticalAlign: 'middle',
    fontSize: 13,
  },
  badgeNeutral: {
    display: 'inline-block',
    background: '#F0F2F5',
    color: '#555',
    borderRadius: 6,
    padding: '3px 9px',
    fontSize: 12,
    fontWeight: 600,
  },
  numericBold: {
    fontWeight: 700,
    color: '#1a1a2e',
    fontVariantNumeric: 'tabular-nums',
  },
  valueBold: {
    fontWeight: 700,
    color: '#1a7a45',
    fontVariantNumeric: 'tabular-nums',
  },
  actionsCell: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  actionBtn: (color) => ({
    width: 34,
    height: 34,
    borderRadius: 8,
    border: 'none',
    background: `${color}22`,
    color: color,
    fill: color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 15,
    lineHeight: 1,
    transition: 'background 0.15s',
    flexShrink: 0,
    outline: 'none',
  }),
  footer: {
    padding: '14px 24px',
    borderTop: '1px solid #F0F0F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
  },
  footerInfo: {
    fontSize: 13,
    color: '#999',
  },
  emptyState: {
    padding: '60px 24px',
    textAlign: 'center',
    color: '#aaa',
  },
  emptyIcon: {
    fontSize: 48,
    marginBottom: 12,
    opacity: 0.3,
  },
  emptyText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#bbb',
    margin: 0,
  },
}

export function ListarOrcamentos() {
  const [orcamentos, setOrcamentos] = useState([])
  const [isOrcamentosLoading, setIsOrcamentosLoading] = useState(true)

  const [isExportSaleLoading, setIsExportSaleLoading] = useState({})
  const [isCloneRequestLoading, setIsCloneRequestLoading] = useState({})
  const [isDeleteRequestLoading, setIsDeleteRequestLoading] = useState({})
  const [selectedFilterSearch, setSelectedFilterSearch] = useState('cliente')
  const [filterSearch, setFilterSearch] = useState('')
  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const endOffset = itemOffset + itemsPerPage
  const [pageCount, setPageCount] = useState(0)

  const navigate = useNavigate()

  const {
    sortedArray: sortedOrcamentos,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(orcamentos, 'pedido')

  const filteredOrcamentos = useMemo(() => {
    const orcamentosFiltered = sortedOrcamentos.filter((orcamento) =>
      String(orcamento[selectedFilterSearch])
        .toLowerCase()
        .includes(String(filterSearch).toLowerCase()),
    )

    if (filterSearch.length > 0 && orcamentosFiltered.length <= 1) {
      setItemOffset(0)
    }

    setPageCount(Math.ceil(orcamentosFiltered.length / itemsPerPage))

    return orcamentosFiltered.slice(itemOffset, endOffset)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endOffset, itemOffset, filterSearch, sortedOrcamentos, orderType.field, orderType.type])

  async function handleExportSale(idOrcamento, index) {
    try {
      setIsExportSaleLoading((prev) => ({ ...prev, [index]: true }))
      const dataMessage = await OrcamentosService.exportToSales(idOrcamento)
      await loadOrcamentos()
      toast.success(dataMessage)
    } catch (err) {
      sendErrorApiMessage(err, 'Houve um erro ao exportar a venda!')
    } finally {
      setIsExportSaleLoading((prev) => ({ ...prev, [index]: false }))
    }
  }

  async function handleClone(idOrcamento, index) {
    try {
      setIsCloneRequestLoading((prev) => ({ ...prev, [index]: true }))
      const responseMessage = await OrcamentosService.clone(idOrcamento)
      toast.success(responseMessage)
      loadOrcamentos()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível clonar o orçamento!')
    } finally {
      setIsCloneRequestLoading((prev) => ({ ...prev, [index]: false }))
    }
  }

  async function handleDeleteOrder(idOrcamento, index) {
    try {
      setIsDeleteRequestLoading((prev) => ({ ...prev, [index]: true }))
      await OrcamentosService.delete(idOrcamento)
      toast.success('Orçamento deletado com sucesso!')
      loadOrcamentos()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível excluir o orçamento!')
    } finally {
      setIsDeleteRequestLoading((prev) => ({ ...prev, [index]: false }))
    }
  }

  async function printPDF(idOrcamento) {
    const { orcamento, itens, empresa, endereco_cliente } =
      await OrcamentosService.getEstimativeToPrint(idOrcamento)

    const {
      pedido, cliente, data, desconto, desconto_din, id_parceiro,
      cpf, cod_vendedor, detalhes_pedido, valor, id_cliente,
    } = orcamento

    const dadosPedido = {
      numeroorc: pedido,
      cliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: cod_vendedor || null,
      data: data || moment().format('YYYY-MM-DD'),
      valor,
      desconto: desconto || null,
      desconto_din: desconto_din || 0,
      id_parceiro: id_parceiro || null,
      cpf,
      dadosDoCliente: endereco_cliente,
      detalhes_pedido: detalhes_pedido || 'Não informado',
      itens,
      empresa: [empresa],
    }

    async function getBase64ImageFromUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.setAttribute('crossOrigin', 'anonymous')
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/jpeg'))
        }
        img.onerror = reject
        img.src = url
      })
    }

    for (let i = 0; i < dadosPedido.itens.length; i++) {
      const item = dadosPedido.itens[i]
      try {
        const imageUrl = item.image
          ? `https://node.ziphub.com.br/imagens/${item.image}`
          : 'https://node.ziphub.com.br/imagens/no-image.jpg'
        item.base64 = await getBase64ImageFromUrl(imageUrl)
      } catch (error) {
        try {
          item.base64 = await getBase64ImageFromUrl('https://node.ziphub.com.br/imagens/no-image.jpg')
        } catch {
          item.base64 = ''
        }
      }
    }

    clientesPDF(dadosPedido, 'Completo')
  }

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % orcamentos.length
    setItemOffset(newOffset)
  }

  async function loadOrcamentos() {
    setIsOrcamentosLoading(true)
    try {
      const data = await OrcamentosService.getAll()
      setOrcamentos(data)
    } catch (error) {
      toast.error('Houve um erro ao listar os orçamentos!')
    } finally {
      setIsOrcamentosLoading(false)
    }
  }

  useEffect(() => {
    loadOrcamentos()
  }, [])

  const SortTh = ({ field, label }) => (
    <th style={styles.th} onClick={() => handleOrganize(field)}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {label}
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <CaretUp size={10} color={check(field, 'asc')} />
          <CaretDown size={10} color={check(field, 'desc')} />
        </span>
      </span>
    </th>
  )

  const totalOrcamentos = sortedOrcamentos.length
  const startItem = itemOffset + 1
  const endItem = Math.min(itemOffset + itemsPerPage, totalOrcamentos)

  return (
    <>
      <Navbar />
      <style>{`
        .orcamentos-table thead th { background-color: #F7F8FA !important; color: #555 !important; }
        .orcamentos-action-btn { display: inline-flex !important; align-items: center !important; justify-content: center !important; }
        .orcamentos-action-btn svg { display: block !important; flex-shrink: 0; }
      `}</style>

      <div style={styles.page}>
        <div style={styles.container}>

          {/* Header */}
          <div style={styles.header}>
            <div style={styles.titleGroup}>
              <div style={styles.titleIcon}>
                <FileEarmarkText />
              </div>
              <div>
                <h1 style={styles.title}>Orçamentos</h1>
                <p style={styles.subtitle}>
                  {totalOrcamentos} orçamento{totalOrcamentos !== 1 ? 's' : ''} no total
                </p>
              </div>
            </div>

            <div style={styles.headerActions}>
              <button
                style={styles.btnSecondary}
                onClick={loadOrcamentos}
                title="Recarregar"
              >
                <ArrowClockwise size={15} />
                Atualizar
              </button>

              <button
                style={styles.btnPrimary}
                onClick={() => navigate(`/orcamento/${localStorage.idconta}/novo`)}
              >
                <PlusCircleFill size={15} />
                Novo Orçamento
              </button>
            </div>
          </div>

          {/* Card principal */}
          <div style={styles.card}>

            {/* Toolbar */}
            <div style={styles.toolbar}>
              <div style={styles.toolbarGroup}>
                <span style={styles.label}>Por página</span>
                <select
                  style={styles.select}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              <div style={styles.toolbarGroup}>
                <span style={styles.label}>Filtrar por</span>
                <select
                  style={styles.select}
                  defaultValue={selectedFilterSearch}
                  onChange={(e) => setSelectedFilterSearch(e.target.value)}
                >
                  <option value="cliente">Cliente</option>
                  <option value="pedido">Número</option>
                  <option value="parceiro">Parceiro / Arquiteto</option>
                </select>
              </div>

              <div style={styles.toolbarGroup}>
                <span style={styles.label}>Pesquisar</span>
                <div style={styles.searchWrapper}>
                  <Search style={styles.searchIcon} />
                  <input
                    style={styles.searchInput}
                    value={filterSearch}
                    onChange={(e) => setFilterSearch(e.target.value)}
                    placeholder="Digite aqui..."
                  />
                </div>
              </div>
            </div>

            {/* Conteúdo */}
            {isOrcamentosLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                <CustomSpinner size={60} />
              </div>
            ) : filteredOrcamentos.length === 0 ? (
              <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>📋</div>
                <p style={styles.emptyText}>
                  {filterSearch ? 'Nenhum orçamento encontrado para esta pesquisa.' : 'Nenhum orçamento cadastrado.'}
                </p>
              </div>
            ) : (
              <>
                <div style={styles.tableWrapper}>
                  <table style={styles.table} className="orcamentos-table">
                    <thead style={styles.thead}>
                      <tr>
                        <SortTh field="pedido" label="Número" />
                        <SortTh field="data" label="Data" />
                        <SortTh field="cliente" label="Cliente" />
                        <SortTh field="parceiro" label="Parceiro / Arquiteto" />
                        <SortTh field="valor" label="Valor" />
                        <th style={styles.thNoSort}>Canal de Venda</th>
                        <th style={styles.thNoSort}>Pedido Loja</th>
                        <th style={styles.thNoSort}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOrcamentos.map((orc, index) => (
                        <tr
                          key={orc.pedido}
                          style={{ transition: 'background 0.12s' }}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#FAFBFC'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          <td style={styles.td}>
                            <span style={styles.numericBold}>#{orc.pedido}</span>
                          </td>
                          <td style={styles.td}>{formatDate(orc.data)}</td>
                          <td style={styles.td}>
                            <span style={{ fontWeight: 500, color: '#222' }}>{orc.cliente}</span>
                          </td>
                          <td style={styles.td}>
                            {orc.parceiro
                              ? <span style={styles.badgeNeutral}>{orc.parceiro}</span>
                              : <span style={{ color: '#ccc' }}>—</span>
                            }
                          </td>
                          <td style={styles.td}>
                            <span style={styles.valueBold}>{formatPrice(orc.valor)}</span>
                          </td>
                          <td style={styles.tdMuted}>{orc.id_loja || '—'}</td>
                          <td style={styles.tdMuted}>{orc.idpedidoloja || '—'}</td>
                          <td style={styles.td}>
                            <div style={styles.actionsCell}>

                              <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                                <button
                                  style={styles.actionBtn('#f39c12')} className="orcamentos-action-btn"
                                  onClick={() => navigate(`/orcamento/${localStorage.idconta}/${orc.pedido}`)}
                                >
                                  <PencilFill size={13} />
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                                <button
                                  style={styles.actionBtn('#e74c3c')} className="orcamentos-action-btn"
                                  onClick={() => {
                                    Swal.fire({
                                      title: `Excluir orçamento #${orc.pedido}?`,
                                      text: 'Esta ação não pode ser desfeita.',
                                      showCancelButton: true,
                                      confirmButtonText: 'Excluir',
                                      confirmButtonColor: '#e74c3c',
                                      cancelButtonText: 'Cancelar',
                                    }).then((result) => {
                                      if (result.isConfirmed) handleDeleteOrder(orc.pedido, index)
                                    })
                                  }}
                                >
                                  {isDeleteRequestLoading[index]
                                    ? <span style={{ fontSize: 10 }}>...</span>
                                    : <TrashFill size={13} />
                                  }
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger overlay={<Tooltip>Clonar</Tooltip>}>
                                <button
                                  style={styles.actionBtn('#3498db')} className="orcamentos-action-btn"
                                  onClick={() => {
                                    Swal.fire({
                                      title: `Clonar orçamento #${orc.pedido}?`,
                                      showCancelButton: true,
                                      confirmButtonText: 'Clonar',
                                      confirmButtonColor: '#3498db',
                                      cancelButtonText: 'Cancelar',
                                    }).then((result) => {
                                      if (result.isConfirmed) handleClone(orc.pedido, index)
                                    })
                                  }}
                                >
                                  {isCloneRequestLoading[index]
                                    ? <span style={{ fontSize: 10 }}>...</span>
                                    : <Copy size={13} />
                                  }
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger overlay={<Tooltip>Imprimir</Tooltip>}>
                                <button
                                  style={styles.actionBtn('#27bac1')} className="orcamentos-action-btn"
                                  onClick={() => printPDF(orc.pedido)}
                                >
                                  <PrinterFill size={13} />
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger overlay={<Tooltip>Transformar em Pedido</Tooltip>}>
                                <button
                                  style={styles.actionBtn('#7445e1')} className="orcamentos-action-btn"
                                  onClick={() => handleExportSale(orc.pedido, index)}
                                >
                                  {isExportSaleLoading[index]
                                    ? <span style={{ fontSize: 10 }}>...</span>
                                    : <ShareFill size={13} />
                                  }
                                </button>
                              </OverlayTrigger>

                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Footer com paginação */}
                <div style={styles.footer}>
                  <span style={styles.footerInfo}>
                    Exibindo {startItem}–{endItem} de {totalOrcamentos} orçamentos
                  </span>

                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Próxima →"
                    previousLabel="← Anterior"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination pagination-sm mb-0"
                    activeClassName="active"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}